export default "__VITE_ASSET__BIIEUn4N__"